import MainRegistrantPage from '@/modules/traceability-contract/views/pages/main/registrant.vue';
import MainApproverPage from '@/modules/traceability-contract/views/pages/main/approver.vue';
import CreatePage from '@/modules/traceability-contract/views/pages/create/index.vue';
import EditPage from '@/modules/traceability-contract/views/pages/edit/index.vue';
import ViewPage from '@/modules/traceability-contract/views/pages/view/index.vue';

const routes = [
    {
        path: '/contrato-rastreabilidade',
        name: 'contrato-rastreabilidade',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE'
            ]
        },
        component: MainRegistrantPage
    },
    {
        path: '/contrato-rastreabilidade/comprador',
        name: 'contrato-rastreabilidade-comprador',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: MainApproverPage
    },
    {
        path: '/contrato-rastreabilidade/cadastro',
        name: 'contrato-rastreabilidade-cadastro',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE'
            ]
        },
        component: CreatePage
    },
    {
        path: '/contrato-rastreabilidade/:id/visualizar',
        name: 'contrato-rastreabilidade-visualizar',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE'
            ]
        },
        component: ViewPage
    },
    {
        path: '/contrato-rastreabilidade/:id/editar',
        name: 'contrato-rastreabilidade-editar',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE'
            ]
        },
        component: EditPage
    }
];

export default routes;
